module.exports = __webpack_public_path__ + "img/pos7_banner2.a8035379.png";